import { CardExchange } from '../model';
import { getParams } from '../util/urlParam';
import { exhibitioninfo, langList  } from '../variables';
import { Lang, t } from '../util/translate';
import dayjs from 'dayjs';

export const CardExchangeCard = (props: CardExchange) => {
  
  const domain = process.env.GIFT_NET_URL;

  // クエリ取得
  const params = getParams(exhibitioninfo);

  // 言語設定 クエリ優先 -> localStorage
  let lang = 'ja' as keyof Lang
  if (langList.indexOf(String(params.lang)) !== -1) {
    lang = params.lang as keyof Lang;
    localStorage.setItem('lang', lang);
  }else{
    lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
  }

  // updated_atのフォーマット
  let formatDate: string = '';
  formatDate = dayjs(props.exchanged_at).format('YYYY/MM/DD');

  return `
 
  <div class="col-xs-12 col-md-4  p-4">
    <div class="namecard-result__card card card-shadow">
      <div class="card-body">
        <p>
          <a href="${domain}page/shops/${props.shop_id}?lang=${lang}" >
            <h5 class="card-title namecard-result__title">${props.company_name}</h5>
          </a>
        </p>
        <p>${t.mp_cardname1[lang]}：${props.name}</p>
        <p>TEL：${props.phone_number}</p>
        <p>${t.mp_cardname2[lang]}：${props.address}</p>
        <div class="d-flex flex-row-reverse bd-highlight">
          <div class="p-2 bd-highlight">
            <span class="namecard-result__date d-block">${t.mp_cardname3[lang]}: ${formatDate}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  `;
};
